<template>
    <app-table
        clickable
        deletable
        highlight-rows-on-hover
        :data="items"
        :order="params.order"
        :page-size="params.limit"
        :loading="listLoading"
        @rowClick="showTemplateDetail"
        @deleteRow="deleteItem"
    >
        <app-table-column :label="translations.showName">
            <template slot-scope="row">
                <strong>{{ row._show.name }}</strong>
            </template>
        </app-table-column>

        <app-table-column :label="translations.epgChannel">
            <template slot-scope="row">
                <template v-if="row._epgChannels.length === 0">
                    0
                </template>
                <template v-else>
                      <span class="dotted">
                        {{ row._epgChannels.length }}
                        <span class="help_popup help_popup--no-wrap">
                          <strong>{{ translations.applyToSelectedTvStations }}</strong> <br />

                          <table style="margin-top: 10px;">
                            <thead>
                              <th class="first_data">Název</th>
                            </thead>
                            <tr v-for="epgChannel in row._epgChannels">
                              <td>{{ epgChannel.name }}</td>
                            </tr>
                          </table>
                         </span>
                      </span>
                </template>
            </template>
        </app-table-column>

        <app-table-column :label="translations.backoffice">
            <template slot-scope="row">
                <template v-if="row._backoffices.length === 0">
                    0
                </template>
                <template v-else>
                            <span class="dotted">
                            {{ row._backoffices.length }}
                            <span class="help_popup help_popup--no-wrap">
                              <strong>{{ translations.applyToSelectedBackoffices }}</strong> <br />

                              <table style="margin-top: 10px;">
                                <thead>
                                  <th class="first_data">Název</th>
                                  <th>API Url</th>
                                </thead>
                                <tr v-for="backoffice in row._backoffices">
                                  <td>{{ backoffice.name }}</td>
                                  <td>{{ backoffice.api_url }}</td>
                                </tr>
                              </table>
                             </span>
                        </span>
                </template>
            </template>
        </app-table-column>

        <app-table-column :label="translations.enabled">
            <template slot-scope="row">
                <app-graphic-image
                    :value="row.enabled"
                />
            </template>
        </app-table-column>
        <app-table-column :label="translations.allowTs">
            <template slot-scope="row">
                <app-graphic-image
                    :value="row.allowTs"
                />
            </template>
        </app-table-column>
        <app-table-column :label="translations.allowCatchup">
            <template slot-scope="row">
                <app-graphic-image
                    :value="row.allowCatchup"
                />
            </template>
        </app-table-column>
        <app-table-column :label="translations.allowPvr">
            <template slot-scope="row">
                <app-graphic-image
                    :value="row.allowPvr"
                />
            </template>
        </app-table-column>

        <app-table-column :label="translations.updated">
            <template slot-scope="row">
                <div v-html="formatDate(row._updated)" />
            </template>
        </app-table-column>

        <template slot="footer" v-if="itemsMetadata.totalCount > params.limit">
            <app-table-pagination
                :page="listPage"
                :itemsPerPage="params.limit"
                :totalCount="itemsMetadata.totalCount"
                @pageChanged="tablePageChanged"
            />
        </template>
    </app-table>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isNilOrEmpty } from 'ramda-adjunct'
import { showErrorWithTimeout } from '@/utils/form'
import { showDeleteDialog } from '@/utils/dialog'
import formatDateMixin from '../../../mixins/formatDateMixin'
import getItemsListMixin from 'mixins/getItemsListMixin'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'BlackoutContentTemplates',
  preventFetchOnCreated: true
})

export default {
  name: 'blackoutContentTemplates',
  mixins: [
    formatDateMixin,
    itemsListMixin
  ],
  props: {
    parentId: {
      type: Number,
      default: false
    }
  },
  created() {
    this.fetchBlackoutContentTemplates(false)
  },
  data() {
    return {
      listPage: 1
    }
  },
  computed: {
    ...mapState({
      items: state => state.blackoutContentTemplates.blackoutContentTemplates,
      itemsMetadata: state => state.blackoutContentTemplates.blackoutContentTemplatesMetadata,
    }),
    translations() {
      return {
          addGlobalRecords: this.$gettext('Zobrazit záznamy bez určení Backoffice'),
          applyToSelectedBackoffices: this.$gettext('Blokování je aplikováno pouze na vybrané Backoffice.'),
          applyToSelectedTvStations: this.$gettext('Blokování je aplikováno na vybrané kanály.'),
          backoffice: this.$gettext('Backoffice'),
          universalBlock: this.$gettext('Univerzální blokace'),
          epgChannel: this.$gettext('EPG Kanály'),
          enabled: this.$gettext('Povoleno'),
          allowTs: this.$gettext('TS'),
          allowCatchup: this.$gettext('CU'),
          allowPvr: this.$gettext('PVR'),
          addBlackoutContentTemplate: this.$gettext('Přidat šablonu blokování'),
          showName: this.$gettext('Pořad'),
          apiUrl: this.$gettext('API Url'),
          updated: this.$gettext('Upraveno'),
      }
    },
    listLoading() {
      return this.pending && isNilOrEmpty(this.items)
    }
  },
  methods: {
    ...mapActions([
      'getBlackoutContentTemplates',
      'deleteBlackoutContentTemplate',
    ]),
    shouldRefreshAfterDelete() {
      return true
    },
    showTemplateDetail(item) {
        this.$router.push({
            name: 'blackoutContentTemplate',
            params: {
                id: item._id,
            }
        });
    },
    deleteItem(item) {
      const deleteError = this.getDeleteError(item)
      if (deleteError) {
        showErrorWithTimeout(this, deleteError)
      } else {
        showDeleteDialog(this, {
          apiMethod: 'deleteBlackoutContentTemplate',
          params: {
            id: item._id
          }
        }, this.getDeleteMessage(item))
      }
    },
    getDeleteError() {
      return null
    },
    getDeleteMessage() {
      return null
    },
    fetchBlackoutContentTemplates(resetPage) {
      if (resetPage && this.listPage !== 1) {
        this.tablePageChanged(1, false)
        return
      }
      this.getBlackoutContentTemplates({ params: {...this.params, showId: this.parentId }});
    },
    tablePageChanged(page, fetchItems = true) {
      this.listPage = page
      this.params.offset = (this.listPage - 1) * this.params.limit
      if (fetchItems) {
        this.fetchBlackoutContentTemplates(false)
      }
    }
  }
}
</script>
